import { apiSlice } from './apiSlice';

const FACULTY_URL = '/api/faculty';

export const facultyApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getFaculty: builder.query({
      query: () => ({
        url: FACULTY_URL,
        method: 'GET'
      }),
      providesTags: ['Faculty']
    }),
    getFacultyById: builder.query({
      query: (id) => ({
        url: `${FACULTY_URL}/${id}`,
        method: 'GET'
      }),
      providesTags: (result, error, id) => [{ type: 'Faculty', id }]
    }),
    createFaculty: builder.mutation({
      query: (data) => ({
        url: FACULTY_URL,
        method: 'POST',
        body: data
      }),
      validateStatus: (response, result) => {
        return response.status >= 200 && response.status <= 299;
      },
      transformResponse: (response) => {
        if (!response) {
          console.warn('Empty response from createFaculty endpoint');
          return { success: true };
        }
        return response;
      },
      transformErrorResponse: (response) => {
        const status = response.status;
        console.log('Error response from API:', response);
        
        if (status === 500) {
          console.log('Received 500 error from server, checking for MongoDB duplicate key error...');
          console.log('Error data:', JSON.stringify(response.data || {}, null, 2));
          
          // Check for MongoDB duplicate key error (E11000) in different parts of the response
          // This error might appear in different properties depending on how the backend handles it
          const errorText = JSON.stringify(response.data || {});
          const isDuplicateKeyError = 
            errorText.includes('E11000') || 
            errorText.includes('duplicate key') ||
            errorText.includes('already exists') ||
            errorText.toLowerCase().includes('duplicate');
          
          if (isDuplicateKeyError) {
            console.log('Detected MongoDB duplicate key error in the server response');
            return {
              status: 409,
              data: { 
                message: 'Faculty with this email already exists',
                success: false,
                originalError: response.data,
                errorDetails: errorText
              }
            };
          }
          
          return {
            status: status,
            data: { 
              message: 'Server error occurred but the faculty may have been created successfully. Please check the faculty list.',
              possibleSuccess: true,
              originalError: response.data
            }
          };
        }
        
        if (status === 201) {
          console.warn('Received 201 status with error, might be false error:', response);
          return {
            status: status,
            data: { 
              message: 'Created successfully despite error response',
              success: true,
              originalError: response.data
            }
          };
        }
        
        return response;
      },
      invalidatesTags: ['Faculty']
    }),
    updateFaculty: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `${FACULTY_URL}/${id}`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Faculty', id }]
    }),
    deleteFaculty: builder.mutation({
      query: (id) => ({
        url: `${FACULTY_URL}/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['Faculty']
    }),
    getFacultyProfile: builder.query({
      query: () => ({
        url: `${FACULTY_URL}/profile`,
        method: 'GET'
      }),
      providesTags: ['FacultyProfile']
    })
  })
});

export const {
  useGetFacultyQuery,
  useGetFacultyByIdQuery,
  useCreateFacultyMutation,
  useUpdateFacultyMutation,
  useDeleteFacultyMutation,
  useGetFacultyProfileQuery
} = facultyApiSlice; 